export const UI_LANGUAGE_STORAGE_KEY = 'ag-language';
export const UI_LANGUAGES = ['uk', 'en'] as const;
export const DEFAULT_UI_LANGUAGE = 'uk';

export type UiLanguage = (typeof UI_LANGUAGES)[number];

export function isUiLanguage(value: unknown): value is UiLanguage {
  return typeof value === 'string' && UI_LANGUAGES.includes(value as UiLanguage);
}

export function getInitialUiLanguage(savedLanguage: string | null): UiLanguage {
  return isUiLanguage(savedLanguage) ? savedLanguage : DEFAULT_UI_LANGUAGE;
}

export function readStoredUiLanguage(): UiLanguage {
  try {
    return getInitialUiLanguage(window.localStorage.getItem(UI_LANGUAGE_STORAGE_KEY));
  } catch {
    return DEFAULT_UI_LANGUAGE;
  }
}

export function persistUiLanguage(language: UiLanguage): void {
  try {
    window.localStorage.setItem(UI_LANGUAGE_STORAGE_KEY, language);
  } catch {
    // The UI remains usable when browser storage is unavailable.
  }
}
